import React, { useState } from 'react';
import logo from './me.PNG';

// Functional Component
const Home = () => {
  return (
    <div className="homeContent">
        <div id="main_hello">
        <p>Hello!</p>
        <p>My name is Benney</p>
        <p>I'm a <b>Software Developer</b></p>
        </div>
        <div id="main_pic_container">
        <img
            id="main_pic" src={logo} className="App-logo" alt="logo" />
        </div>
    </div>
  );
};

export default Home;